var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3327 16.12L9.60602 14.3933L8.66602 15.3333L11.3327 18L15.9993 13.3333L15.0593 12.3933L11.3327 16.12Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 4.00008C3.70283 4.00008 4.0013 3.7016 4.0013 3.33341C4.0013 2.96522 3.70283 2.66675 3.33464 2.66675C2.96645 2.66675 2.66797 2.96522 2.66797 3.33341C2.66797 3.7016 2.96645 4.00008 3.33464 4.00008Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 9.33333C3.70283 9.33333 4.0013 9.03486 4.0013 8.66667C4.0013 8.29848 3.70283 8 3.33464 8C2.96645 8 2.66797 8.29848 2.66797 8.66667C2.66797 9.03486 2.96645 9.33333 3.33464 9.33333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33464 14.6666C3.70283 14.6666 4.0013 14.3681 4.0013 13.9999C4.0013 13.6317 3.70283 13.3333 3.33464 13.3333C2.96645 13.3333 2.66797 13.6317 2.66797 13.9999C2.66797 14.3681 2.96645 14.6666 3.33464 14.6666Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H1.33333C0.979711 0 0.640573 0.140476 0.390524 0.390524C0.140476 0.640573 0 0.979711 0 1.33333V16C0 16.3536 0.140476 16.6928 0.390524 16.9428C0.640573 17.1929 0.979711 17.3333 1.33333 17.3333H6.66667V16H1.33333V12H13.3333V1.33333C13.3333 0.979711 13.1929 0.640573 12.9428 0.390524C12.6928 0.140476 12.3536 0 12 0ZM12 10.6667H1.33333V6.66667H12V10.6667ZM12 5.33333H1.33333V1.33333H12V5.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.d389f5a5cc121bf3b3f83c2d6ad1e55c.svg";
export { ForwardRef as ReactComponent };